class AutocompleteAPILayer {
  constructor () {
    this.eventBus = window.theme.autocomplete.eventBus
    this.events = window.theme.autocomplete.events
    this.config = window.theme.autocomplete.config

    this.setupEventListeners()

    this.trackingEvents()
  }

  trackingEvents () {
    this.eventBus.subscribe(
      this.events.TRACKING.PRODUCT_CLICKED,
      productData => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return
        window.nostojs(api => {
          api.recordSearchClick('autocomplete', {
            productId: productData.productId,
            url: productData.productUrl,
          })
        })
      },
    )

    this.eventBus.subscribe(
      this.events.TRACKING.PRODUCT_ADDED_TO_CART,
      productData => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return

        window.nostojs(api => {
          api.recordSearchAddToCart('autocomplete', {
            productId: productData.hit.productId,
            url: productData.hit.productUrl,
          })
        })
      },
    )

    this.eventBus.subscribe(
      this.events.TRACKING.KEYWORD_CLICKED,
      searchData => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return
        const { request, results } = searchData

        window.nostojs(api => {
          api.recordSearch('autocomplete', request, results, {
            isKeyword: true,
          })
        })
      },
    )

    this.eventBus.subscribe(this.events.TRACKING.SUBMIT_SEARCH, searchData => {
      const { query } = searchData
      window.nostojs(api => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return
        api.recordSearchSubmit('autocomplete', query)
      })
    })
  }

  setupEventListeners () {
    this.eventBus.subscribe(this.events.API.ACTIVE_TERM_UPDATED, term => {
      this.fetchResults(term)
    })
  }

  emptySearchQuery () {
    return {
      query: '',
      popularSearches: {
        size: this.config.popularSearchSize,
        emptyQueryMatchesAll: true,
      },
      categories: {
        size: this.config.categorySize,
        emptyQueryMatchesAll: true,
      },
      keywords: {
        size: this.config.keywordSize,
        emptyQueryMatchesAll: true,
      },
    }
  }

  populateSearchQuery (term) {
    return {
      query: term,
      minQueryLength: 1,
      products: {
        fields: [
          'name',
          'imageUrl',
          'alternateImageUrls',
          'price',
          'customFields.key',
          'customFields.value',
          'listPrice',
          'url',
          'skus.name',
          'skus.id',
          'skus.inventoryLevel',
        ],
        size: this.config.productSize,
      },
      categories: { size: this.config.categorySize },
      keywords: {
        fields: ['keyword'],
        size: this.config.keywordSize,
      },
    }
  }

  async fetchResults (term) {
    const searchQuery = term
      ? this.populateSearchQuery(term)
      : this.emptySearchQuery()

    try {
      // eslint-disable-next-line no-undef
      nostojs(api => {
        api
          .search(searchQuery, {
            track: term ? 'autocomplete' : undefined,
          })
          .then(response => {
            this.eventBus.publish(this.events.API.QUERY_FETCHED, response)
          })
          .catch(error => {
            console.error('Failed to fetch products from Nosto:', error)
            this.eventBus.publish(this.events.API.FETCH_FAILED, {})
          })
      })
    } catch (error) {
      console.error('NostoJS API call failed:', error)
      this.eventBus.publish(this.events.API.FETCH_FAILED, {})
    }
  }
}

// Initialize and attach to window for debugging
window.theme.autocomplete.apiLayer = new AutocompleteAPILayer()
